export default __webpack_public_path__ + "static/media/cardDesigner.3cbedb9e.svg";